"use client";
import * as e from "react";
import { getCoreRowModel as t, getExpandedRowModel as n, getFilteredRowModel as r, getPaginationRowModel as i, getSortedRowModel as a, useReactTable as o } from "@tanstack/react-table";
// src/components/data-table/use-data-table.ts
function s({ columns: s, data: c, enableRowSelection: l = !1, rowSelection: u, onRowSelectionChange: d, selectedRowIds: f, onSelectedRowIdsChange: p, enableSorting: ee = !0, sorting: m, onSortingChange: h, expandable: g, subrows: _, pagination: v, enableColumnResizing: te = !1, columnResizeMode: ne = "onChange", enableColumnReorder: y = !1, onColumnOrderChange: b, initialColumnOrder: re, getRowId: x, editable: S }) {
	let [C, w] = e.useState([]), T = h !== void 0, E = T ? m ?? [] : C, [ie, ae] = e.useState([]), [D, O] = e.useState({}), [k, oe] = e.useState(() => _?.defaultExpanded ?? {}), [A, j] = e.useState(() => new Set(g?.expandedRowIds ?? g?.defaultExpanded ?? [])), [M, N] = e.useState(() => ({
		pageIndex: 0,
		pageSize: v?.pageSize ?? 10
	})), [se, ce] = e.useState({}), [P, F] = e.useState(re ?? []), [I, L] = e.useState(null), R = S?.editingCell !== void 0, z = R ? S.editingCell ?? null : I, B = e.useCallback((e) => {
		R ? S?.onEditingCellChange?.(e) : L(e);
	}, [R, S]), [V, H] = e.useState(null), [U, W] = e.useState(null), [le, G] = e.useState(!1), K = v ?? {}, q = (K.mode ?? "client") === "client", [ue, de] = e.useState(() => v?.pageSize);
	K.pageSize !== ue && (de(K.pageSize), K.pageSize !== void 0 && K.pageSize !== M.pageSize && N({
		pageIndex: 0,
		pageSize: K.pageSize
	}));
	let J = q ? M.pageIndex : Math.max(0, K.page ?? 0), Y = M.pageSize, X = q ? c.length : Math.max(0, K.totalItems ?? 0), Z = Math.max(1, Math.ceil((X || 1) / Math.max(1, Y))), fe = J + 1, pe = e.useMemo(() => {
		if (u) return u;
		if (f) {
			let e = new Set(f);
			return c.reduce((t, n, r) => {
				if (e.has(n)) {
					let e = String(x ? x(n, r) : n?.id ?? r);
					t[e] = !0;
				}
				return t;
			}, {});
		}
		return D;
	}, [
		u,
		f,
		D,
		x,
		c
	]), me = e.useCallback((e) => {
		if (d) {
			d(e);
			return;
		}
		let t = f ? f.reduce((e, t) => {
			let n = String(x ? x(t, -1) : t?.id);
			return n && (e[n] = !0), e;
		}, {}) : D, n = typeof e == "function" ? e(t) : e;
		if (p) {
			let e = new Set(Object.keys(n)), t = [], r = /* @__PURE__ */ new Set(), i = (e, t) => String(x ? x(e, t) : e?.id ?? t);
			c.forEach((n, a) => {
				let o = i(n, a);
				e.has(o) && (t.push(n), r.add(o));
			}), f && f.forEach((n, a) => {
				let o = i(n, a);
				e.has(o) && !r.has(o) && (t.push(n), r.add(o));
			}), p(t);
		}
		O(n);
	}, [
		d,
		p,
		f,
		D,
		c,
		x
	]), Q = e.useCallback((e) => {
		j((t) => {
			let n = g?.expandedRowIds, r = n ? new Set(n) : new Set(t);
			return r.has(e) ? r.delete(e) : r.add(e), g?.onExpandChange?.(Array.from(r)), r;
		});
	}, [g]), $ = o({
		data: c,
		columns: s,
		state: {
			sorting: E,
			columnFilters: ie,
			rowSelection: pe,
			...q && { pagination: M },
			columnSizing: se,
			columnOrder: P,
			expanded: k
		},
		meta: {
			expandedRows: A,
			handleToggleExpand: Q
		},
		getRowId: x ? (e, t, n) => {
			let r = String(x(e, t));
			return n ? `${n.id}.${r}` : r;
		} : (e, t, n) => {
			let r = String(e?.id ?? t);
			return n ? `${n.id}.${r}` : r;
		},
		manualPagination: !q,
		pageCount: q ? void 0 : Z,
		enableRowSelection: typeof l == "boolean" ? l : (e) => l(e.original),
		manualSorting: T,
		onSortingChange: T ? h : w,
		onColumnFiltersChange: ae,
		onRowSelectionChange: me,
		onColumnSizingChange: ce,
		onColumnOrderChange: (e) => {
			F(e), b?.(e);
		},
		onExpandedChange: (e) => {
			if (oe(e), _?.onExpandedChange) {
				let t = typeof e == "function" ? e(k) : e;
				_.onExpandedChange(t);
			}
		},
		getSubRows: _?.getSubRows,
		getRowCanExpand: _?.getRowCanExpand,
		getCoreRowModel: t(),
		getFilteredRowModel: r(),
		...q ? { getPaginationRowModel: i() } : {},
		...T ? {} : { getSortedRowModel: a() },
		getExpandedRowModel: n(),
		columnResizeMode: ne
	});
	e.useEffect(() => {
		g?.expandedRowIds && j(new Set(g.expandedRowIds));
	}, [g?.expandedRowIds]), e.useEffect(() => {
		if (!P || P.length === 0) {
			let e = $.getAllLeafColumns().map((e) => e.id);
			F(e);
		}
	}, []);
	let he = e.useCallback((e, t) => x ? x(e.original, t) : e.original?.id ?? e.id, [x]);
	return {
		table: $,
		sorting: E,
		expandedRows: A,
		expanded: k,
		editingCell: z,
		setEditingCell: B,
		pagination: M,
		setPagination: N,
		columnOrder: P,
		draggedColumnId: V,
		dragOverColumnIndex: U,
		isColumnReordering: le,
		columnDragHandlers: e.useMemo(() => ({
			onDragStart: (e) => {
				y && (H(e), G(!0), W(null));
			},
			onDragOver: (e, t) => {
				y && (e.preventDefault(), e.dataTransfer.dropEffect = "move", W((e) => e === t ? e : t));
			},
			onDrop: (e, t) => {
				if (e.preventDefault(), !y) return;
				let n = e.dataTransfer.getData("text/column-id");
				if (!n) return;
				let r = $.getAllLeafColumns(), i = r.findIndex((e) => e.id === n);
				if (i === -1 || i === t) {
					W(null), H(null), G(!1);
					return;
				}
				let a = [...r.map((e) => e.id)], [o] = a.splice(i, 1);
				a.splice(t, 0, o || ""), W(null), H(null), G(!1), F(a), b?.(a);
			},
			onDragEnd: () => {
				H(null), W(null), G(!1);
			}
		}), [
			y,
			b,
			$
		]),
		handleToggleExpand: Q,
		extractRowId: he,
		isClient: q,
		pager: K,
		resolvedPageIndex: J,
		resolvedPageSize: Y,
		totalItems: X,
		totalPages: Z,
		currentPage: fe
	};
}
export { s as useDataTable };

//# sourceMappingURL=use-data-table.js.map